import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import EditCategoryComponent from '../components/EditCategoryComponent';
import HeaderComponent from '../components/HeaderComponent';

class EditCategoryPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <EditCategoryComponent id={this.props.match.params.id}/>
            </div>
        );
    }
}

export default EditCategoryPage;